import React, { FC, useEffect, useState } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import envs from 'config/envs';

interface IUnauthenticatedProps {}

const Unauthenticated: FC<IUnauthenticatedProps> = (props) => {
  const [redirecting, setRedirecting] = useState(true);
  // Note: we intentionally do NOT forward query params like `redirectUrl` to `/login`.
  // In this admin app, the Login page does not consume `redirectUrl`,
  // and forwarding it causes a redirectUrl->login->unauthenticated->login loop.
  const redirectPath = window.location.search;
  
  // Stay on same origin for login when on admin domain or local dev (avoid redirect to port 3001)
  const isOnAdminDomain =
    window.location.hostname === 'admin.starfarm.com' ||
    window.location.hostname.includes('starfarm-admin') ||
    window.location.hostname.includes('vercel.app') ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (isOnAdminDomain) {
        // Stay on admin domain - redirect to admin login (no query params to avoid loops)
        window.location.href = `${window.location.origin}/login`;
      } else if (envs.streamerUri) {
        // Only redirect to streamer if NOT on admin domain
        window.location.href = `${envs.streamerUri}/login`;
      } else {
        setRedirecting(false);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [redirectPath, isOnAdminDomain]);

  if (redirecting && (isOnAdminDomain || envs.streamerUri)) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
        bgcolor="#02172a"
        color="#fff"
      >
        <Typography variant="h5" gutterBottom>
          Redirecting to login...
        </Typography>
      </Box>
    );
  }

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      justifyContent="center" 
      alignItems="center" 
      minHeight="100vh"
      bgcolor="#02172a"
      color="#fff"
      p={3}
    >
      <Typography variant="h4" gutterBottom>
        Authentication Required
      </Typography>
      <Typography variant="body1" gutterBottom style={{ marginTop: 16 }}>
        Please log in to access the admin dashboard.
      </Typography>
      {isOnAdminDomain ? (
        <Button 
          variant="contained" 
          color="primary" 
          style={{ marginTop: 24 }}
          onClick={() => window.location.href = `${window.location.origin}/login`}
        >
          Go to Admin Login
        </Button>
      ) : envs.streamerUri ? (
        <Button 
          variant="contained" 
          color="primary" 
          style={{ marginTop: 24 }}
          onClick={() => window.location.href = `${envs.streamerUri}/login`}
        >
          Go to Login
        </Button>
      ) : null}
      {!envs.streamerUri && (
        <Typography variant="body2" style={{ marginTop: 16, color: '#ff9800' }}>
          Error: Login URL not configured. Please set REACT_APP_STREAMER_APP in .env
        </Typography>
      )}
    </Box>
  );
};

export default Unauthenticated;
